export interface BreadcrumbItem {
  label: string;
  iconComponent: string;
  route: string;
}

export interface PageInfo {
  breadcrumb: BreadcrumbItem[];
  title: string;
  route: string;
}

export const BREADCRUMB_MAP = {
  '/': {
    breadcrumb: [{label: 'Início', iconComponent: 'home', route: '/'}],
    title: 'Início',
    route: '/',
  },
  '/controle-usuarios': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Usuários', iconComponent: 'controle-user', route: '/controle-usuarios'},
    ],
    title: 'Controle de Usuários',
    route: '/controle-usuarios',
  },
  '/demandas': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas'},
    ],
    title: 'Controle de Demandas',
    route: '/demandas',
  },
  '/demandas/lista': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas/lista'},
    ],
    title: 'Controle de Demandas',
    route: '/demandas/lista',
  },
  '/controle-demandas/mapa-calor': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas/mapa-calor'},
    ],
    title: 'Controle de Demandas',
    route: '/demandas/mapa-calor',
  },
  '/demandas/adicionar': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas'},
      {label: 'Cadastro de Nova Demanda', iconComponent: 'archive-book', route: '/demandas/adicionar'},
    ],
    title: 'Cadastro de Nova Demanda',
    route: '/demandas/adicionar',
  },
  '/demandas/adicionar/descricao': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas'},
      {label: 'Cadastro de Nova Demanda', iconComponent: 'archive-book', route: '/demandas/adicionar'},
    ],
    title: 'Cadastro de Nova Demanda',
    route: '/demandas/adicionar/descricao',
  },
  '/demandas/adicionar/anexos': {
    breadcrumb: [
      {label: 'Início', iconComponent: 'home', route: '/'},
      {label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas'},
      {label: 'Cadastro de Nova Demanda', iconComponent: 'archive-book', route: '/demandas/adicionar'},
    ],
    title: 'Cadastro de Nova Demanda',
    route: '/demandas/adicionar/anexos',
  },
};
